// extracted by mini-css-extract-plugin
module.exports = {"no_token_icon":"NoTokenIcon_no_token_icon__3KSSS"};